import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

import globalConfig from '../config';

const config = globalConfig.firebase;
if (!firebase.apps.length) {
  firebase.initializeApp(config);
  // const settings = { timestampsInSnapshots: true };
  // firebase.firestore().settings(settings);
}

export default firebase;
